import {
  getAuth,
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInWithEmailLink
} from 'firebase/auth';

import { onRegister, onSignIn } from '../hooks';
import { app } from '...modules/firebase/web';
import getHttpsCallable from '...utils/getHttpsCallable';

const auth = getAuth(app);
const authRegisterUser = getHttpsCallable('authRegisterUser');

export const send = async (email, queryString = '') => {
  const actionSettings = {
    url: `${process.env.ROOT_URL}/auth/magic-link${queryString}`,
    handleCodeInApp: true
  };
  await sendSignInLinkToEmail(auth, email, actionSettings);
  window.localStorage.setItem('magicLinkEmail', email);
};

export const register = async ({ displayName = '', company, email }) => {
  await send(email, `?n=${encodeURIComponent(displayName)}&c=${encodeURIComponent(company)}`);
};

export const signIn = async (newUserData) => {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    let email = window.localStorage.getItem('magicLinkEmail');
    if (!email) {
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again.
      email = window.prompt('Please provide your email for confirmation');
    }

    try {
      const userCredential = await signInWithEmailLink(auth, email, window.location.href);
      window.localStorage.removeItem('magicLinkEmail');
      if (newUserData?.n && newUserData?.c) {
        const result = await authRegisterUser({
          displayName: newUserData.n,
          company: newUserData.c
        });
        console.log('authRegisterUser response', result.data);
        console.log('id token updated...force refreshing token');
        onRegister('email-link', userCredential);
      } else {
        onSignIn('email-link', userCredential);
      }
      return userCredential;
    } catch (e) {
      console.error(e);
      alert(e.message);
    }
  }
};
